import React from 'react';

interface Props {
    purchaseDocument:any;
}

const PurchaseDocumentTotal = ({ purchaseDocument }: Props) => {
    return (
        <div className="purchase-invoice-total">
            <div className="row justify-content-end">
                <div className="col-md-3">
                    <div className="input-group mb-2">
                        <span className="input-group-text fw-bold">Total Neto:</span>
                        <input
                            type="text"
                            id="totalNet"
                            className="form-control text-end"
                            value={purchaseDocument?.total_neto || ''}
                            disabled
                        />
                    </div>

                    <div className="input-group mb-2">
                        <span className="input-group-text fw-bold">Total Impuestos:</span>
                        <input
                            type="text"
                            id="totalNet"
                            className="form-control text-end"
                            value={purchaseDocument?.total_tax || ''}
                            disabled
                        />
                    </div>

                    <div className="input-group mb-2">
                        <span className="input-group-text fw-bold">Total:</span>
                        <input
                            type="text"
                            id="totalNet"
                            className="form-control text-end"
                            value={purchaseDocument?.total_amount || ''}
                            disabled
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PurchaseDocumentTotal;
